export interface LevelState {
  level: number;
  speedMultiplier: number;
}

export interface TickLevelResult {
  state: LevelState;
  leveledUp: boolean;
}

export const MAX_LEVEL = 8;
export const SPEED_INCREMENT = 1.2;

export function createLevelState(): LevelState {
  return { level: 1, speedMultiplier: 1.0 };
}

export function tickLevel(
  state: LevelState,
  enemiesRemaining: number,
): TickLevelResult {
  if (enemiesRemaining > 0) {
    return { state, leveledUp: false };
  }
  if (state.level >= MAX_LEVEL) {
    return { state, leveledUp: true };
  }
  return {
    state: {
      level: state.level + 1,
      speedMultiplier: state.speedMultiplier * SPEED_INCREMENT,
    },
    leveledUp: true,
  };
}
